import { LodashUtilityService } from './lodash-utility-service';

export class ArrayUtilityService {
	static getIndexOfObjectInArray(array: Array<any>, item: any): number {
		return LodashUtilityService.findIndex(array, item);
	}

	static findObjectInArray(
		array: Array<any>,
		propertyName: any,
		propertyValue: any
	): any {
		return array?.find((item) => item[propertyName] === propertyValue);
	}
}
